export function celebrateParser(obj) {
  if (obj.respCode === -1) {
    if (obj.message === 'DATA-ERROR') {
      if (obj.validation && obj.validation.body) {
        obj.detailedMessage = obj.validation.body.message.replace(
          '[f]',
          obj.validation.body.keys.toString(),
        );
      }
    }
  }
}
